import {
  EventActionsEnum,
  EventActionTypesEnum,
  EventModuleTypesEnum,
  EventViewTypesEnum,
  rudderstackIdentify,
  trackAnalyticsErrorEvent,
  trackAnalyticsEvent,
} from '@agridigital/waypath-analytics-ts-shared.fe-analytics-utils';
import { Visibility, VisibilityOff, Warning } from '@mui/icons-material';
import { Button, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { isEmpty } from 'lodash';

import Logo from '../../assets/AgriDigital_Lockup_Horizontal_Colour.svg';

const auth_api_url = process.env.REACT_APP_AUTH_API;

const Login = ({ history }: any) => {
  const [username, setUsername] = useState<string>('');
  const [usernameActive, setUsernameActive] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordActive, setPasswordActive] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [loginError, setLoginError] = useState('');
  const [login, setLogin] = useState<Record<any, any>>({});
  const axios = require("axios").default;

  const handleChange = (event: any) => {
    const value = event.target.value;
    setLogin({
      ...login,
      [event.target.name]: value,
    });
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setIsSubmitting(true);

    const userTraits = {
      username: login.username,
      email: login.username,
    };
    rudderstackIdentify(userTraits);

    setIsSubmitting(true);
    axios({ method: "post", url: auth_api_url, data: login })
      .then((response: any) => {
        trackAnalyticsEvent('home_login', {
          module: EventModuleTypesEnum.AUTH,
          view: 'login',
          action: EventActionsEnum.SUBMIT,
          actionType: EventActionTypesEnum.API,
          formsubmitresult: 'Success',
        });
        setIsSubmitting(false);
        localStorage.setItem("accessToken", response.data.accessToken);
        response.data.accessToken && history.push("/dashboard");
      })
      .catch((err: any) => {
        // setLoginError(get(err, 'message'));
        setLoginError('An error occurred. Please try again.');
        trackAnalyticsErrorEvent('home_login', {
          type: err.type,
          err: JSON.stringify(serializeError(err)),
          errResponse: JSON.stringify(serializeError(err)),
          errStatus: err.status,
          errMessage: err.message,
          formsubmitresult: 'Failure',
        });
        setIsSubmitting(false);
        console.error("ERROR:", err);
      });
  };
  return (
      <div className='grid grid-cols-2 gap-4 p-8 md:grid-cols-6 md:gap-8 md:p-12 xl:grid-cols-12 xl:gap-10 xl:p-16 h-full'>
        {/* Primary Container */}
        <div className="col-span-2 md:col-start-2 md:col-span-4 xl:col-start-5 xl:col-span-4">
          <img
            src={Logo}
            alt="logo"
            className="m-auto mb-12"
            style={{ height: 64 }}
          />
          <p className="text-5xl text-center mb-8 font-foundersGroteskCondensed text-agEarth500 font-semibold">
            Insights{" "}
          </p>
          <p className="text-xl text-center font-foundersGrotesk text-agEarth500 mb-6">
            Welcome to AgriDigital Insights (formerly Waypath Insights)
          </p>

          <form className="" onSubmit={handleSubmit}>
          <TextField
            placeholder='Enter your email...'
            fullWidth
            type='email'
            name="username"
            autoComplete="current-password"
            helperText={usernameActive ? 'Please use your AgriDigital Onfarm email address' : ' '}
            onFocus={() => {
              setLoginError('');
              setUsernameActive(true);
            }}
            onBlur={() => setUsernameActive(false)}
            value={username}
            onChange={(e: any) => {
              setLoginError('');
              setUsername(e.target.value);
              handleChange(e)
            }}
          />

          

          <TextField
            placeholder="Enter your password..."
            fullWidth
            name="password"
            autoComplete="current-password"
            type={passwordVisible ? 'text' : 'password'}
            FormHelperTextProps={{ className: 'helper' }}
            helperText={
              passwordActive ? 'Please use your AgriDigital Onfarm password' : ' '
            }
            onFocus={() => {
              setLoginError('');
              setPasswordActive(true);
            }}
            onBlur={() => setPasswordActive(false)}
            value={password}
            onChange={(e: any) => {
              setLoginError('');
              setPassword(e.target.value);
              handleChange(e)
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {password && (
                    <>
                      {passwordVisible ? (
                        <VisibilityOff
                          className="text-gray-darker"
                          onClick={() => {
                            setPasswordVisible(false);
                          }}
                        />
                      ) : (
                        <Visibility
                          className="text-gray-darker"
                          onClick={() => {
                            setPasswordVisible(true);
                          }}
                        />
                      )}
                    </>
                  )}
                </InputAdornment>
              ),
            }}
          />
          {!isEmpty(loginError) && (
            <div className="flex mt-2 justify-center">
              <div className="mr-2">
                <Warning style={{color: 'red'}} />
              </div>
              <div className="text-xs error self-center" style={{color: 'red'}}>{loginError}</div>
            </div>
          )}

          


            <button
              disabled={isSubmitting}
              type="submit"
              className="font-semibold uppercase mt-8 px-12 py-5 leading-none leading-none text-lg rounded-full bg-agBarley500 text-agWhite font-foundersGrotesk w-full hover:bg-agBarley600 focus:outline-none"
            >
              {isSubmitting ? (
                <div className="flex flex-row justify-center items-center">
                  <p>Logging In</p>
                  <FaSpinner className="ml-2 animate-spin" />
                </div>
              ) : (
                <p>Login</p>
              )}
            </button>
          </form>
          <div className="self-start my-5">
            <p>
              Don’t have Insights access?
              <a
                className="cursor-pointer hyperLink"
                href="https://info.agridigital.io/insights"
                target="_blank"
                rel="noreferrer"
                onClick={e => {
                  trackAnalyticsEvent('insights_access', {
                    module: EventModuleTypesEnum.AUTH,
                    view: EventViewTypesEnum.FORM,
                    action: EventActionsEnum.VIEW,
                    actionType: EventActionTypesEnum.CLICK,
                    description: 'signUpTrialLink',
                  });
                }}
              >
                Click here to request access.
              </a>
            </p>
          </div>
          <div className="my-12 text-xs text-left">
            {`AgriDigital Insights is in beta testing. Feedback is welcome by clicking`}
            <span
              className="underline cursor-pointer hyperLink"
              onClick={() => {
                trackAnalyticsEvent('insights_feedback', {
                  module: EventModuleTypesEnum.AUTH,
                  view: EventViewTypesEnum.FORM,
                  action: EventActionsEnum.VIEW,
                  actionType: EventActionTypesEnum.CLICK,
                  description: 'AgriDigital Insights Beta feedback',
                });
                window.open('https://agridigital.hellonext.co/b/Insights-Feedback', '_blank');
              }}
            >
              {`here`}
            </span>
          </div>
        </div>
        <div className="col-span-1 md:col-span-3 xl:col-span-6 self-end">
          <div className="flex items-center">
            <a
              className="cursor-pointer hyperLinkBlack"
              href="https://status.waypath.io/"
              target="_blank"
              rel="noreferrer"
              onClick={e => {
                trackAnalyticsEvent('status_check', {
                  module: EventModuleTypesEnum.AUTH,
                  view: 'login',
                  action: EventActionsEnum.VIEW,
                  actionType: EventActionTypesEnum.CLICK,
                });
              }}
            >
              SERVICE STATUS
            </a>
          </div>
        </div>
        <div className="col-span-1 md:col-span-3 xl:col-span-6 self-end text-right">
          <Button
            className="largeButton default"
            variant="outlined"
            type="submit"
            onClick={e => {
              e.preventDefault();
              trackAnalyticsEvent('support_click', {
                module: EventModuleTypesEnum.AUTH,
                view: 'login',
                action: EventActionsEnum.VIEW,
                actionType: EventActionTypesEnum.CLICK,
              });
              window.open('https://knowledgebase.waypath.io/hc/en-us', '_blank');
            }}
          >
            SUPPORT
          </Button>
        </div>
      </div>

  );
};

export default Login;
function serializeError(err: any): any {
  return err;
  // throw new Error('Function not implemented.');
}

